import { ModalActionConfig } from "@components/action-modal/action-modal.component";


export const actionModalCancelTrip: ModalActionConfig = {
    title: 'action_modal.cancel_trip.title',
    subtitle: 'action_modal.cancel_trip.subtitle',
    buttons: [
        {
            id: 'yes',
            cssClass: 'cancel',
            text: 'action_modal.cancel_trip.button_yes'
        },
        {
            id: 'no',
            cssClass: 'secondary',
            text: 'action_modal.cancel_trip.button_no'
        },
    ]
}

export const actionModalContinueWaiting: ModalActionConfig = {
    title: 'action_modal.continue_waiting.title',
    subtitle: 'action_modal.continue_waiting.subtitle',
    buttons: [
        {
            id: 'yes',
            cssClass: 'general',
            text: 'general.yes'
        },
        {
            id: 'no',
            cssClass: 'secondary',
            text: 'general.no'
        },
    ]
}

export const actionModalRateAppConfirm: ModalActionConfig = {
    title: 'action_modal.rate_app_confirm.title',
    subtitle: 'action_modal.rate_app_confirm.subtitle',
    buttons: [
        {
            id: 'yes',
            cssClass: 'general',
            text: 'action_modal.rate_app_confirm.button_yes'
        },
        {
            id: 'no',
            cssClass: 'secondary',
            text: 'action_modal.rate_app_confirm.button_no'
        },
    ]
}

export const actionModalRateApp: ModalActionConfig = {
    title: 'action_modal.rate_app.title',
    subtitle: 'action_modal.rate_app.subtitle',
    buttons: [
        {
            id: 'yes',
            cssClass: 'general',
            text: 'action_modal.rate_app.button_yes',
            action: true
        },
        {
            id: 'no',
            cssClass: 'secondary',
            text: 'action_modal.rate_app.button_no'
        },
    ],
    arrayInputs: [
        {
            id: 'rate',
            values: [1, 2, 3, 4, 5],
            defaultValue: [1, 2, 3, 4, 5],
        }
    ],
    inputs: [
        {
            id: 'comment',
            inputMode: 'textarea',
            defaultValue: '',
            // type: 'text',
            // icon: 'dp-copy',
            placeholder: 'action_modal.rate_app.comment_placeholder',
            // validators: [Validators.required],
            disabled: false
        }
    ]
}

export const actionModalCallDriver: ModalActionConfig = {
    title: 'action_modal.call_driver.title',
    subtitle: 'action_modal.call_driver.subtitle',
    inputs: [
        {
            id: 'phoneNumber',
            inputMode: 'input',
            defaultValue: '+44 671 46 78 34',
            type: 'text',
            icon: 'dp-copy',
            placeholder: '',
            // validators: [Validators.required],
            disabled: true
        }
    ],
    buttons: [
        {
            id: 'whatsapp',
            cssClass: 'general',
            text: 'action_modal.call_driver.button_whats_app',
            icon: 'dp-whatsapp',
            action: true
        },
        {
            id: 'back',
            cssClass: 'secondary',
            text: 'action_modal.call_driver.button_back'
        },
    ]
}

export const actionModalChatOptions: ModalActionConfig = {
    title: 'action_modal.options_chat.title',
    buttons: [
        {
            id: 'delete',
            cssClass: 'cancel',
            text: 'action_modal.options_chat.button_delete',
        },
    ]
}

export const actionModalShowError: ModalActionConfig = {
    title: '',
    buttons: [
        {
            id: 'ok',
            cssClass: 'general',
            text: 'action_modal.show_error.okay',
        },
    ]
}
